"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Request = require("./_request-api");
var Settings = require("./settings");
var constants_1 = require("../data/constants");
var signedInCallbacks = [];
var signedOutCallbacks = [];
var pingInterval = 5 * 60 * 1000;
var pingId;
var sessionStarted = false;
var ping = function () {
    return Request
        .sendPost(constants_1.endpoints.api + "/user/ping");
};
var updateCallback = function (list, callback) {
    var index = list
        .map(function (f) { return f.toString(); })
        .indexOf(callback.toString());
    if (index < 0) {
        list.push(callback);
    }
    else {
        list[index] = callback;
    }
    return callback;
};
var whenLogin = function (token) {
    Settings.set("token", token);
    signedInCallbacks.forEach(function (callback) {
        if (callback && sessionStarted) {
            callback(token);
        }
    });
    return token;
};
var whenLogout = function (platformToken) {
    if (platformToken === void 0) { platformToken = null; }
    Settings.set("token", {
        platform_token: (Settings.get("token") || {}).platform_token || platformToken,
    });
    signedOutCallbacks.forEach(function (callback) {
        if (callback && sessionStarted) {
            callback();
        }
    });
    return;
};
var signedIn = function () {
    var token = Settings.get("token");
    if (!token) {
        return false;
    }
    if (!token.access_token) {
        return false;
    }
    if (!token.expires_in) {
        return true;
    }
    var expire = token.created_at + token.expires_in;
    var now = (new Date()).getTime() / 1000;
    return expire > now;
};
exports.signedIn = signedIn;
var login = function (email, password, scope, platformName) {
    if (scope === void 0) { scope = "user"; }
    if (platformName === void 0) { platformName = null; }
    var headers = scope === "admin" ? { PlatformTokenName: platformName } : {};
    return Request
        .sendPost(constants_1.endpoints.api + "/oauth/token", {
        grant_type: "password",
        username: email,
        password: password,
        scope: scope,
    }, headers)
        .then(whenLogin);
};
exports.login = login;
var logout = function () {
    var token = Settings.get("token") || {};
    var accessToken = (Settings.get("token") || {}).access_token;
    return (token.access_token
        ? Request.sendPost(constants_1.endpoints.api + "/oauth/revoke", { token: accessToken })
        : Promise.resolve())
        .then(whenLogout);
};
exports.logout = logout;
var register = function (params) {
    return Request
        .sendPost(constants_1.endpoints.api + "/users", params)
        .then(whenLogin);
};
exports.register = register;
var unregister = function () {
    return Request
        .sendDelete(constants_1.endpoints.api + "/user")
        .then(whenLogout);
};
exports.unregister = unregister;
var onSignedIn = function (callback) {
    updateCallback(signedInCallbacks, callback);
    if (signedIn() && callback && sessionStarted) {
        setTimeout(callback);
    }
};
exports.onSignedIn = onSignedIn;
var onSignedOut = function (callback) {
    updateCallback(signedOutCallbacks, callback);
    if (!signedIn() && callback && sessionStarted) {
        setTimeout(callback);
    }
};
exports.onSignedOut = onSignedOut;
var init = function (platformToken) {
    sessionStarted = true;
    if (signedIn()) {
        whenLogin(Settings.get("token", {
            platform_token: platformToken,
        }));
    }
    else {
        whenLogout(platformToken);
    }
};
exports.init = init;
onSignedIn(function () {
    ping();
    pingId = pingId || setInterval(function () {
        if (!pingId) {
            return;
        }
        ping();
    }, pingInterval);
});
onSignedOut(function () {
    if (!pingId) {
        return;
    }
    clearInterval(pingId);
    pingId = null;
});
//# sourceMappingURL=session.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/session.js
// module id = 856
// module chunks = 3